import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceRight3.vue?vue&type=template&id=3d7a8f24&"
import script from "./FaceDirectionResultEffectFaceRight3.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceRight3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports